import React, { useEffect, useState, useRef } from "react";
import Slider from 'react-slick';
import lottie from 'lottie-web';
import InView from 'react-intersection-observer';
import Parallax from "../common/utils/animations/parallax";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";

function GridLayout(props) {
  const { header, subHeader, gridItems, classes } = props.data;
  const [svgRef, setsvgRef] = useState([useRef(), useRef(), useRef(), useRef(), useRef(), useRef(), useRef(), useRef(), useRef(),]);
  const [isVisible, setisVisible] = useState(false);
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 1023);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });


  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className={`${classes}`} id={props.id ? props.id : ''}>
      <InView as="div" className="section-title" onChange={(inView) => setisVisible(inView)}>
        <div className="container">
          {header && <h2>{header}</h2>}
          {subHeader && <p>{subHeader}</p>}
        </div>
      </InView>
      <div className="grid-layout-section service-inner-three-col">
        <div className="container">
          {isMobile && <>
            <div className="row d-flex flex-wrap">
              <Slider {...settings}>
                {gridItems && gridItems.map((item) => {
                  return (<div className="col grid-item">
                    <div className="item-inner">
                      <div className="grid-icon">
                        <i className="icon-small">{item.icon}</i>
                      </div>
                      <h3>{item.header}</h3>
                      <p>{item.content}</p>
                    </div>
                  </div>);
                })}
              </Slider>
            </div>
          </>}
          {!isMobile && <>
            <div className="row d-flex flex-wrap">
              {gridItems && gridItems.map((item, index) => {
                return (
                  <InView as="div" className="col grid-item" key={index} onChange={(inView) => {
                    if (inView && item.svgIcon)
                      lottie.loadAnimation({
                        container: svgRef[index].current,
                        renderer: "svg",
                        loop: false,
                        autoplay: true,
                        animationData: item.svgIcon
                      });
                  }} triggerOnce={true}>
                    {/* <div className="col grid-item" key={index}> */}
                    <Parallax classes="item-inner" id={"grid-item-inner-" + index} triggers={[1, 0.7]}>
                      <div className="grid-icon">
                        {/* <div className="svg-small" ref={svgRef[index]}></div> */}
                        <i className="icon-small">{item.icon}</i>
                      </div>
                      <h3>{item.header}</h3>
                      <p>{item.content}</p>
                    </Parallax>
                    {/* </div> */}
                  </InView>);
              })}

            </div>
          </>}
        </div>
      </div>
    </div >
  );
};

export default GridLayout;